import { render } from "./FutGameSearch.vue?vue&type=template&id=c8b5db02&scoped=true"
import script from "./FutGameSearch.vue?vue&type=script&lang=js"
export * from "./FutGameSearch.vue?vue&type=script&lang=js"

import "./FutGameSearch.vue?vue&type=style&index=0&id=c8b5db02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b5db02"]])

export default __exports__